import logo from './logo.svg';
import './App.css';
import {HashRouter, Redirect, Route, Switch} from "react-router-dom";
import HomePage from "./pages";
import ConsolePage from "./pages/console/console";
import {connect} from "react-redux";

const App = ({loggedIn,...props}) => {
  return (
    <div className="App">
      <HashRouter>
          <Switch>
              <Route path={'/home'} component={HomePage}/>
              {
                  loggedIn &&
                  <Route path={'/projects'} component={ConsolePage}/>
              }
              
              <Redirect to={'/home'}/>
          </Switch>
      </HashRouter>
    </div>
  );
}

const mapStateToProps = (store) => ({
    loggedIn: store.appReducer.loggedIn

})

export default connect(mapStateToProps)(App);
